module.exports = __webpack_public_path__ + "img/tab4.4590087f.png";